import {SWITCH_LOADER , FETCH_LOCATION, LOCATION_DENIED} from "../action/actionConstants";

export default function InputBox(state = {loader : false, fetchLocation : false, locationDenied :false} , action) {
  switch (action.type) {

    case SWITCH_LOADER: {
      return {...state,
       loader: action.payload
     }
   }
   case FETCH_LOCATION: {
     return {...state,
      fetchLocation: action.payload
    }
  }

  case LOCATION_DENIED: {
    return {...state,
     locationDenied: action.payload
   }
 }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loader.js